var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import ts, { factory, SyntaxKind } from "typescript";
import { Formatter } from "../../../definition/context-types";
import { MuiDetailComponents } from "../../../definition/material-ui/detail";
import { getProperties } from "../../entity";
import { getPropertyType, PropertyType } from "../../graphql/typeAlias";
import { createNamedImportDeclaration, createNameSpaceImport, uniqueImports, } from "../../../ast/imports";
import ReactIntlFormatter from "../../react-components/react-intl/intl-formatter";
import { InputType } from "./input-types";
import { createAst, findByCondition, replaceElementsToAST, transformer, } from "../../../../ast";
import { findVariableDeclarations, findObjectLiteralExpression, findPropertyAssignment, printSourceCode, } from "../../../ast/ast";
import { findWidgetParentNode, getWidgetProperties } from "../../../ast/widgetDeclaration";
import { clearNodePosition, createStringJsxAttribute, isJsxAttributeWithName } from "../../../ast/node";
import { getEntityName } from "../../entity/helper";
var MuiDetailGenerator = /** @class */ (function () {
    function MuiDetailGenerator(generationContext, entity, widgetContext) {
        var _this = this;
        this._imports = [];
        this.createInputElementFromTemplate = function (property, template) {
            if (template === void 0) { template = ''; }
            var propName = property.getName();
            var propType = PropertyType.string; // getPropertyType(property);
            if (template === '') {
                template = _this.getDefaultInputTemplateByPropertyType(propType);
            }
            if (template) {
                var ast = createAst(template);
                if (ast) {
                    var transformIdAttribute_1 = function (node) {
                        var attributeName = 'id';
                        if (isJsxAttributeWithName(node, attributeName)) {
                            return createStringJsxAttribute(attributeName, propName);
                        }
                    };
                    var transformLabelAttribute_1 = function (node) {
                        var attributeName = 'label';
                        if (isJsxAttributeWithName(node, attributeName)) {
                            return createStringJsxAttribute(attributeName, propName);
                        }
                    };
                    var transformValueAttribute_1 = function (node) {
                        var attributeName = 'value';
                        if (isJsxAttributeWithName(node, attributeName)) {
                            return _this.createValueJsxAttribute(propName, propType);
                        }
                    };
                    var transformOnChangeAttribute_1 = function (node) {
                        var attributeName = 'onChange';
                        if (isJsxAttributeWithName(node, attributeName)) {
                            return _this.createFormikOnChangeAttribute(propName);
                        }
                    };
                    var transformInputTemplate = function (node) {
                        return transformIdAttribute_1(node) || transformLabelAttribute_1(node) || transformValueAttribute_1(node) || transformOnChangeAttribute_1(node);
                    };
                    var transformationResult = ts.transform(ast, [transformer(transformInputTemplate)]);
                    return printSourceCode(transformationResult.transformed[0]);
                }
            }
        };
        this.getDefaultInputTemplateByPropertyType = function (propType) {
            switch (propType) {
                case PropertyType.string: {
                    return "\n          import React from 'react';\n          import { useIntl } from 'react-intl';\n          import { TextField } from '@material-ui/core';\n          \n          export const StringInputTemplate = ({ value, handleChange, error }) => {\n            const intl = useIntl();\n          \n            const T = (name: string): string => {\n              return intl.formatMessage({ id: name });\n            };\n          \n            return (\n              <TextField\n                  fullWidth\n                  id=\"id\"\n                  type=\"input\"\n                  label={T('label')} \n                  value={value} \n                  onChange={handleChange}\n              />\n            );\n          };        \n        ";
                }
                default: return '';
            }
        };
        this._context = generationContext;
        this._entity = entity;
        this._widgetContext = widgetContext;
        this._intlFormatter = new ReactIntlFormatter(generationContext, this._imports);
        this._dataPropertyName = getEntityName(this._entity);
    }
    MuiDetailGenerator.prototype.getFormWidgetProperties = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            var result, sourceCode, ast;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {
                            properties: []
                        };
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(position)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            result = this.getFormWidgetPropertiesFromAst(ast, position);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, result];
                }
            });
        });
    };
    MuiDetailGenerator.prototype.getFormWidgetPropertiesFromAst = function (ast, position) {
        var result = {
            properties: []
        };
        var pos = ast.getPositionOfLineAndCharacter(position.lineNumber - 1, position.columnNumber - 1);
        var element = findByCondition(ast, function (node) {
            return node.pos === pos;
        });
        if (element) {
            result.properties = getWidgetProperties(element);
        }
        return result;
    };
    MuiDetailGenerator.prototype.setFormWidgetProperties = function (position, widgetProperties) {
        return __awaiter(this, void 0, void 0, function () {
            var result, sourceCode, ast, pos_1, element, astChanged_1, newProps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(position)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            pos_1 = ast.getPositionOfLineAndCharacter(position.lineNumber - 1, position.columnNumber - 1);
                            element = findByCondition(ast, function (node) {
                                return node.pos === pos_1;
                            });
                            if (element) {
                                if (ts.isJsxOpeningElement(element) || ts.isJsxSelfClosingElement(element)) {
                                    astChanged_1 = false;
                                    newProps = element.attributes.properties.map(function (prop) {
                                        var newProp = prop;
                                        if (ts.isJsxAttribute(prop)) {
                                            var propName_1 = prop.name.escapedText.toString();
                                            var inputProp = widgetProperties.properties.find(function (l) { return l.name === propName_1; });
                                            if (inputProp) {
                                                if (prop.initializer) {
                                                    if (ts.isStringLiteral(prop.initializer)) {
                                                        if (inputProp.value !== prop.initializer.text) {
                                                            newProp = factory.updateJsxAttribute(prop, prop.name, factory.createStringLiteral(inputProp.value));
                                                            astChanged_1 = true;
                                                        }
                                                    }
                                                    else if (ts.isJsxExpression(prop.initializer)) {
                                                        if (prop.initializer.expression) {
                                                            if (prop.initializer.expression.kind === SyntaxKind.TrueKeyword || prop.initializer.expression.kind === SyntaxKind.FalseKeyword) {
                                                                if (inputProp.value !== prop.initializer.expression.getText()) {
                                                                    var booleanValue = factory.createJsxExpression(undefined, inputProp.value.toLowerCase() === 'true' ? factory.createTrue() : factory.createFalse());
                                                                    newProp = factory.updateJsxAttribute(prop, prop.name, booleanValue);
                                                                    astChanged_1 = true;
                                                                }
                                                            }
                                                            if (ts.isNumericLiteral(prop.initializer.expression)) {
                                                                if (inputProp.value !== prop.initializer.expression.getText()) {
                                                                    var numericValue = factory.createJsxExpression(undefined, factory.createNumericLiteral(inputProp.value));
                                                                    newProp = factory.updateJsxAttribute(prop, prop.name, numericValue);
                                                                    astChanged_1 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    if (inputProp.value.toLowerCase() == 'false') {
                                                        newProp = undefined;
                                                        astChanged_1 = true;
                                                    }
                                                }
                                            }
                                        }
                                        return newProp;
                                    });
                                    if (astChanged_1) {
                                        ast = replaceElementsToAST(ast, element.attributes.pos, factory.createJsxAttributes(newProps.filter(function (l) { return l !== undefined; })));
                                        result = this.printSourceCode(ast);
                                    }
                                }
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, result];
                }
            });
        });
    };
    MuiDetailGenerator.prototype.insertFormWidget = function (position, property, index) {
        return __awaiter(this, void 0, void 0, function () {
            var alteredSource, sourceCode, ast, widgetParentNode, formikDeclarationNode, propertyAssigmentArray, gridContainers, gridElements;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alteredSource = "";
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(position)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        widgetParentNode = findWidgetParentNode(sourceCode, position);
                        if (ast && widgetParentNode) {
                            formikDeclarationNode = this.findGridDeclaration(widgetParentNode);
                            if (formikDeclarationNode) {
                                propertyAssigmentArray = [];
                                findPropertyAssignment(formikDeclarationNode.getChildAt(1), propertyAssigmentArray);
                                if (propertyAssigmentArray) {
                                    ast = this.addNewField(formikDeclarationNode, propertyAssigmentArray, property, ast);
                                }
                            }
                            gridContainers = [];
                            this.findGridContainer(widgetParentNode, gridContainers);
                            if (gridContainers.length > 0) {
                                gridElements = [];
                                this.findGridElement(widgetParentNode, gridElements);
                                if (gridElements) {
                                    ast = this.addNewGridElement(gridElements, gridContainers[0], property, ast, index);
                                    alteredSource = this.printSourceCode(ast);
                                }
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, alteredSource];
                }
            });
        });
    };
    MuiDetailGenerator.prototype.findGridElement = function (parentNode, foundedElements) {
        var _this = this;
        if (parentNode != undefined) {
            if (parentNode.getChildCount() > 0) {
                var children = parentNode.getChildren();
                children.forEach(function (child) {
                    if (ts.isJsxElement(child)) {
                        if (child.getFullText().startsWith("Grid item", 1)) {
                            foundedElements.push(child);
                        }
                        else {
                            _this.findGridElement(child, foundedElements);
                        }
                    }
                    else {
                        _this.findGridElement(child, foundedElements);
                    }
                });
            }
        }
    };
    MuiDetailGenerator.prototype.findGridContainer = function (parentNode, foundedElements) {
        var _this = this;
        if (parentNode != undefined) {
            if (parentNode.getChildCount() > 0) {
                var children = parentNode.getChildren();
                children.forEach(function (child) {
                    if (ts.isJsxElement(child)) {
                        if (child.getFullText().startsWith("Grid container", 1)) {
                            foundedElements.push(child);
                        }
                        else {
                            _this.findGridContainer(child, foundedElements);
                        }
                    }
                    else {
                        _this.findGridContainer(child, foundedElements);
                    }
                });
            }
        }
    };
    MuiDetailGenerator.prototype.addNewGridElement = function (gridElements, gridContainer, property, ast, index) {
        var inputElementCode = this.createInputElementFromTemplate(property);
        if (inputElementCode) {
            var inputElementAst = createAst(inputElementCode);
            if (inputElementAst) {
                var inputElement = findByCondition(inputElementAst, function (node) {
                    return ts.isJsxText(node) || ts.isJsxExpression(node) || ts.isJsxElement(node) || ts.isJsxSelfClosingElement(node) || ts.isJsxFragment(node);
                });
                if (inputElement) {
                    clearNodePosition(inputElement);
                    var gridItemElement = this.createGridItemElement([inputElement]);
                    var newElements = void 0;
                    if (index && index < gridElements.length + 1) {
                        newElements = __spreadArray(__spreadArray(__spreadArray([], gridElements.slice(0, index - 1)), [gridItemElement]), gridElements.slice(index - 1));
                    }
                    else {
                        newElements = __spreadArray(__spreadArray([], gridElements), [gridItemElement]);
                    }
                    return replaceElementsToAST(ast, gridContainer.pos, this.createGridContainer(newElements));
                }
            }
        }
        return ast;
    };
    MuiDetailGenerator.prototype.addNewField = function (ole, propertyAssignmentArray, property, ast) {
        var newField = this.tryCreateInitialValueForProperty(property);
        var newElements = __spreadArray(__spreadArray([], propertyAssignmentArray), [
            newField,
        ]);
        return replaceElementsToAST(ast, ole.pos, factory.createObjectLiteralExpression(newElements, false));
    };
    MuiDetailGenerator.prototype.getUsedFormatter = function (columnsDefinition) {
        return columnsDefinition.elements.length === 0
            ? Formatter.None
            : columnsDefinition.elements[0].properties
                .length > 3
                ? Formatter.ReactIntl
                : Formatter.None;
    };
    MuiDetailGenerator.prototype.printSourceCode = function (sourceFile) {
        var printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
        return printer.printFile(sourceFile);
    };
    MuiDetailGenerator.prototype.findGridDeclaration = function (widgetParent) {
        var array = [];
        findVariableDeclarations(widgetParent, array);
        if (array.length > 0) {
            var formikDeclaration = array.filter(function (def) {
                return def.getChildAt(0).getFullText().trim() === "formik";
            });
            var arrayOle = [];
            findObjectLiteralExpression(formikDeclaration[0], arrayOle);
            if (arrayOle) {
                return arrayOle[1];
            }
        }
        return undefined;
    };
    MuiDetailGenerator.prototype.getDetailDefinition = function () {
        return MuiDetailComponents;
    };
    MuiDetailGenerator.prototype.generateDetailComponent = function () {
        if (this._entity) {
            var statements = this.createStatements();
            var functionalComponent = this.createConstFunction("GeneratedFormikComponent", statements);
            this._imports = __spreadArray(__spreadArray([], this._imports), this._intlFormatter.getImports());
            var uniqueFileImports = uniqueImports(this._imports);
            uniqueFileImports.push(createNameSpaceImport("React", "react"));
            uniqueFileImports.push(createNamedImportDeclaration("TextField, Avatar, Card, CardHeader, CardContent, Grid", "@material-ui/core"));
            uniqueFileImports.push(createNamedImportDeclaration("useFormik", "formik"));
            uniqueFileImports.push(createNamedImportDeclaration(this._entity.getName(), "./" + this._entity.getName()));
            return {
                functionDeclaration: functionalComponent,
                imports: uniqueFileImports,
            };
        }
        else
            return undefined;
    };
    MuiDetailGenerator.prototype.createStatements = function () {
        var statements = new Array();
        if (this._context.formatter === Formatter.ReactIntl) {
            statements.push(this._intlFormatter.getImperativeHook());
        }
        var fields = this.createInputsForEntity();
        var card = this.createCardElement(fields);
        var formElement = this.createFormElement(card);
        var wrapper = this.createFormikWrapper(formElement);
        statements.push(factory.createReturnStatement(factory.createParenthesizedExpression(wrapper)));
        return statements;
    };
    MuiDetailGenerator.prototype.createInputsForEntity = function () {
        var _this = this;
        var inputs = [];
        getProperties(this._entity).forEach(function (property) {
            var propertyInput = _this.tryCreateInputForProperty(property);
            if (propertyInput) {
                inputs.push(propertyInput);
            }
        });
        return inputs;
    };
    MuiDetailGenerator.prototype.tryCreateInputForProperty = function (property) {
        var propType = getPropertyType(property);
        var propertyName = property.getName();
        var input;
        switch (propType) {
            case PropertyType.string: {
                if (propertyName.toLocaleLowerCase().includes("avatar")) {
                    input = this.createAvatarElement(propertyName);
                }
                else {
                    input = this.createTextFieldElement(propertyName, propertyName, InputType.text);
                }
                break;
            }
            case PropertyType.datetime:
                input = this.createTextFieldElement(propertyName, propertyName, InputType.date);
                break;
        }
        return input;
    };
    MuiDetailGenerator.prototype.createTextFieldComponent = function (name, text) {
        return factory.createJsxSelfClosingElement(factory.createIdentifier("TextField"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("fullWidth"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("id"), factory.createStringLiteral(this._dataPropertyName + "." + name)),
            factory.createJsxAttribute(factory.createIdentifier("type"), factory.createStringLiteral("input")),
            this.createLabelAttribute(name),
            this.getTextValueAttribute(name, InputType.text),
            factory.createJsxAttribute(factory.createIdentifier("onChange"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("handleChange")))),
        ]));
    };
    MuiDetailGenerator.prototype.createCheckboxComponent = function (name) {
        return factory.createJsxSelfClosingElement(factory.createIdentifier("Checkbox"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("id"), factory.createStringLiteral("isActive")),
            factory.createJsxAttribute(factory.createIdentifier("value"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name)))),
            factory.createJsxAttribute(factory.createIdentifier("onChange"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("handleChange")))),
        ]));
    };
    MuiDetailGenerator.prototype.createSubmitButton = function () {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("div"), undefined, factory.createJsxAttributes([])), [
            factory.createJsxText("\
            ", true),
            factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Button"), undefined, factory.createJsxAttributes([
                factory.createJsxAttribute(factory.createIdentifier("type"), factory.createStringLiteral("submit")),
            ])), [factory.createJsxText("Submit", false)], factory.createJsxClosingElement(factory.createIdentifier("Button"))),
            factory.createJsxText("\
        ", true),
        ], factory.createJsxClosingElement(factory.createIdentifier("div")));
    };
    MuiDetailGenerator.prototype.createAvatarElement = function (name) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Grid"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("item"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("md"), factory.createJsxExpression(undefined, factory.createNumericLiteral("6"))),
            factory.createJsxAttribute(factory.createIdentifier("xs"), factory.createJsxExpression(undefined, factory.createNumericLiteral("12"))),
        ])), [
            factory.createJsxSelfClosingElement(factory.createIdentifier("Avatar"), undefined, factory.createJsxAttributes([
                factory.createJsxAttribute(factory.createIdentifier("id"), factory.createStringLiteral(this._dataPropertyName + "." + name)),
                factory.createJsxAttribute(factory.createIdentifier("src"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name)))),
            ])),
        ], factory.createJsxClosingElement(factory.createIdentifier("Grid")));
    };
    MuiDetailGenerator.prototype.createFormElement = function (card) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("form"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("onSubmit"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("handleSubmit")))),
        ])), [card], factory.createJsxClosingElement(factory.createIdentifier("form")));
    };
    MuiDetailGenerator.prototype.createDateComponent = function (name, label) {
        return factory.createJsxSelfClosingElement(factory.createIdentifier("TextField"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("fullWidth"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("id"), factory.createStringLiteral(this._dataPropertyName + "." + name)),
            factory.createJsxAttribute(factory.createIdentifier("type"), factory.createStringLiteral("datetime")),
            factory.createJsxAttribute(factory.createIdentifier("disabled"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("label"), factory.createStringLiteral(label)),
            factory.createJsxAttribute(factory.createIdentifier("InputLabelProps"), factory.createJsxExpression(undefined, factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(factory.createIdentifier("shrink"), factory.createTrue()),
            ], false))),
            this.getTextValueAttribute(name, InputType.date),
            factory.createJsxAttribute(factory.createIdentifier("onChange"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("handleChange")))),
        ]));
    };
    MuiDetailGenerator.prototype.getTextValueAttribute = function (name, type) {
        if (this._context.formatter === Formatter.ReactIntl) {
            if (type === InputType.date) {
                return this.createDateValueFormattedAttribute(name);
            }
            else {
                return this.createTextValueFormattedAttribute(name);
            }
        }
        else {
            return this.createTextValueAttribute(name);
        }
    };
    MuiDetailGenerator.prototype.createLabelAttribute = function (name) {
        if (this._context.formatter === Formatter.ReactIntl) {
            return this.createLabelValueFormattedAttribute(name);
        }
        else {
            return this.createLabelValueAttribute(name);
        }
    };
    MuiDetailGenerator.prototype.createCardElement = function (elements) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Card"), undefined, factory.createJsxAttributes([])), [
            factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("CardContent"), undefined, factory.createJsxAttributes([])), [this.createGridContainer(elements)], factory.createJsxClosingElement(factory.createIdentifier("CardContent"))),
        ], factory.createJsxClosingElement(factory.createIdentifier("Card")));
    };
    MuiDetailGenerator.prototype.createGridContainer = function (elements) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Grid"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("container"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("spacing"), factory.createJsxExpression(undefined, factory.createNumericLiteral("3"))),
        ])), elements, factory.createJsxClosingElement(factory.createIdentifier("Grid")));
    };
    MuiDetailGenerator.prototype.createDateValueFormattedAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("value"), factory.createJsxExpression(undefined, factory.createCallExpression(factory.createPropertyAccessExpression(factory.createIdentifier("intl"), factory.createIdentifier("formatDate")), undefined, [
            factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name)),
        ])));
    };
    MuiDetailGenerator.prototype.createTextValueFormattedAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("value"), factory.createJsxExpression(undefined, factory.createCallExpression(factory.createPropertyAccessExpression(factory.createIdentifier("intl"), factory.createIdentifier("formatMessage")), undefined, [
            factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(factory.createIdentifier("'" + "id"), factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name + "'"))),
            ], false),
        ])));
    };
    MuiDetailGenerator.prototype.createTextValueAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("value"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name))));
    };
    MuiDetailGenerator.prototype.createLabelValueFormattedAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("label"), factory.createJsxExpression(undefined, factory.createCallExpression(factory.createPropertyAccessExpression(factory.createIdentifier("intl"), factory.createIdentifier("formatMessage")), undefined, [
            factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(factory.createIdentifier("'" + "id"), factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name + "'"))),
            ], false),
        ])));
    };
    MuiDetailGenerator.prototype.createLabelValueAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("label"), factory.createStringLiteral(name));
    };
    MuiDetailGenerator.prototype.createFormikWrapper = function (formik) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("div"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("style"), factory.createJsxExpression(undefined, factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(factory.createIdentifier("marginLeft"), factory.createNumericLiteral("25")),
                factory.createPropertyAssignment(factory.createIdentifier("marginRight"), factory.createNumericLiteral("25")),
            ], false))),
        ])), [formik], factory.createJsxClosingElement(factory.createIdentifier("div")));
    };
    MuiDetailGenerator.prototype.creteInitialValuesForEntity = function () {
        var _this = this;
        var inputs = [];
        getProperties(this._entity).forEach(function (property) {
            var propertyInput = _this.tryCreateInitialValueForProperty(property);
            if (propertyInput) {
                inputs.push(propertyInput);
            }
        });
        return inputs;
    };
    MuiDetailGenerator.prototype.tryCreateInitialValueForProperty = function (property) {
        var propType = getPropertyType(property);
        var propertyName = property.getName();
        var assignment;
        switch (propType) {
            case PropertyType.string:
                assignment = factory.createPropertyAssignment(factory.createIdentifier(propertyName), factory.createIdentifier(this._dataPropertyName + "." + propertyName));
                break;
            case PropertyType.datetime:
                assignment = factory.createPropertyAssignment(factory.createIdentifier(propertyName), factory.createIdentifier(this._dataPropertyName + "." + propertyName));
                break;
        }
        return assignment;
    };
    MuiDetailGenerator.prototype.getIntlVariable = function () {
        if (this._context.formatter === Formatter.ReactIntl) {
            return this.createUseIntlVariable();
        }
        else {
            return factory.createEmptyStatement();
        }
    };
    MuiDetailGenerator.prototype.createUseIntlVariable = function () {
        return factory.createVariableStatement(undefined, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(factory.createIdentifier("intl"), undefined, undefined, factory.createCallExpression(factory.createIdentifier("useIntl"), undefined, [])),
        ], ts.NodeFlags.Const));
    };
    MuiDetailGenerator.prototype.createFormikVariale = function () {
        return factory.createVariableStatement(undefined, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(factory.createIdentifier("formik"), undefined, undefined, factory.createCallExpression(factory.createIdentifier("useFormik"), undefined, [
                factory.createObjectLiteralExpression([
                    factory.createPropertyAssignment(factory.createIdentifier("initialValues"), factory.createObjectLiteralExpression(this.creteInitialValuesForEntity(), false)),
                    factory.createPropertyAssignment(factory.createIdentifier("onSubmit"), factory.createArrowFunction(undefined, undefined, [
                        factory.createParameterDeclaration(undefined, undefined, undefined, factory.createIdentifier("values"), undefined, undefined, undefined),
                    ], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), factory.createBlock([], false))),
                ], true),
            ])),
        ], ts.NodeFlags.Const));
    };
    MuiDetailGenerator.prototype.createConstFunction = function (componentName, body) {
        var _a;
        return factory.createVariableStatement([factory.createModifier(ts.SyntaxKind.ExportKeyword)], factory.createVariableDeclarationList([
            factory.createVariableDeclaration(factory.createIdentifier(componentName), undefined, factory.createTypeReferenceNode(factory.createQualifiedName(factory.createIdentifier("React"), factory.createIdentifier("FC")), [
                factory.createTypeReferenceNode(factory.createIdentifier((_a = this === null || this === void 0 ? void 0 : this._entity) === null || _a === void 0 ? void 0 : _a.getName()), undefined),
            ]), factory.createArrowFunction(undefined, undefined, [
                factory.createParameterDeclaration(undefined, undefined, undefined, factory.createIdentifier("(" + this._dataPropertyName + ")"), undefined, undefined, undefined),
            ], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), factory.createBlock([
                this.getIntlVariable(),
                this.createFormikVariale(),
                factory.createBlock(body, true),
            ]))),
        ]));
    };
    MuiDetailGenerator.prototype.createTextFieldElement = function (name, text, type) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Grid"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("item"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("md"), factory.createJsxExpression(undefined, factory.createNumericLiteral("6"))),
            factory.createJsxAttribute(factory.createIdentifier("xs"), factory.createJsxExpression(undefined, factory.createNumericLiteral("12"))),
        ])), [this.getTextFieldElement(name, text, type)], factory.createJsxClosingElement(factory.createIdentifier("Grid")));
    };
    MuiDetailGenerator.prototype.getTextFieldElement = function (name, text, type) {
        if (type === InputType.date) {
            return this.createDateComponent(name, text);
        }
        else {
            return this.createTextFieldComponent(name, text);
        }
    };
    MuiDetailGenerator.prototype.createValueJsxAttribute = function (name, propType) {
        // if (this._context.formatter === Formatter.ReactIntl) {
        //   if (type === InputType.date) {
        //     return this.createDateValueFormattedAttribute(name);
        //   } else {
        //     return this.createTextValueFormattedAttribute(name);
        //   }
        // } else {
        //   return this.createTextValueAttribute(name);
        // }
        return this.createFormikValueAttribute(name);
    };
    MuiDetailGenerator.prototype.createFormikValueAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("value"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("values")), factory.createIdentifier(name))));
    };
    MuiDetailGenerator.prototype.createFormikOnChangeAttribute = function (name) {
        return factory.createJsxAttribute(factory.createIdentifier("onChange"), factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(factory.createIdentifier("formik"), factory.createIdentifier("handleChange"))));
    };
    MuiDetailGenerator.prototype.createGridItemElement = function (children) {
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("Grid"), undefined, factory.createJsxAttributes([
            factory.createJsxAttribute(factory.createIdentifier("item"), undefined),
            factory.createJsxAttribute(factory.createIdentifier("md"), factory.createJsxExpression(undefined, factory.createNumericLiteral("6"))),
            factory.createJsxAttribute(factory.createIdentifier("xs"), factory.createJsxExpression(undefined, factory.createNumericLiteral("12"))),
        ])), children, factory.createJsxClosingElement(factory.createIdentifier("Grid")));
    };
    return MuiDetailGenerator;
}());
export default MuiDetailGenerator;
